import { TOAST_CLOSE, TOAST_OPEN } from "./types";

import { createReducer } from "../../utils/reducer-utils";

const initialState = { type: undefined, props: undefined };

const toastsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOAST_OPEN:
      return { type: action.toastType, props: action.toastProps || {} };
    case TOAST_CLOSE:
      return initialState;
    default:
      return state;
  }
};

export default toastsReducer;
